import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {ContactDTO, ContactService} from '../../../Pages/contact/contact/contact.service';
import {HttpErrorResponse} from '@angular/common/http';
import {CountryPickerService, ICountry} from '../../../account/country-picker/country-picker.service';

@Component({
  selector: 'app-contact-form-v2',
  templateUrl: './ContactFormV2.component.html',
  styleUrls: ['./ContactFormV2.component.scss']
})
export class ContactFormV2Component implements OnInit {

  public form: UntypedFormGroup;

  countries: ICountry[];
  success: boolean;
  doNotMatch: string;
  error: string;

  constructor(
    private countryPickerService: CountryPickerService,
    private fb: UntypedFormBuilder,
    private loadingBar: LoadingBarService,
    private contactService: ContactService,
  ) {
  }

  ngOnInit() {
    this.success = false;

    this.countryPickerService.getCountries().subscribe(countries => {
      this.countries = countries.sort((a: ICountry, b: ICountry) => {
        const na = a.name.common;
        const nb = b.name.common;
        if (na > nb) {
          return 1;
        }
        if (na < nb) {
          return -1;
        }
        return 0;
      });
    });

    this.form = this.fb.group({
      recaptcha: ['', Validators.required],
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(254), Validators.email]],
      message: ['', Validators.required, Validators.minLength(5), Validators.maxLength(500)],
      phone: [''],
      country: ['', Validators.required],
      subject: ['', Validators.required],
    });
  }

  handleCaptchaSuccess(recaptcha: string) {
    this.form.get('recaptcha').setValue(recaptcha, {
      onlySelf: true
    });
  }

  changeSubject(e) {
    this.form.get('subject').setValue(e.target.value, {
      onlySelf: true
    });
  }

  changeCountry(e) {
    this.form.get('country').setValue(e.target.value, {
      onlySelf: true
    });
  }


  register() {
    this.loadingBar.useRef('start');

    const email = this.form.get(['email']).value;
    const firstName = this.form.get(['firstName']).value;
    const lastName = this.form.get(['lastName']).value;
    const country = this.form.get(['country']).value;
    const recaptcha = this.form.get(['recaptcha']).value;
    const subject = this.form.get(['subject']).value;
    const message = this.form.get(['message']).value;

    const contactDTO: ContactDTO = {email, firstName, lastName, country, recaptcha, subject, message};
    this.doNotMatch = null;
    this.error = null;


    this.contactService.save(contactDTO).subscribe(
      () => {
        this.success = true;
        this.loadingBar.useRef('stop');
      },
      response => this.processError(response)
    );

  }

  private processError(response: HttpErrorResponse) {
    this.loadingBar.useRef('stop');
    this.success = null;
    this.error = 'ERROR';
  }
}
